import React, {Component} from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import { get_all_drops, resetStorage } from '../../Services/Drop/action';
import {Header} from '../../Components/Header';
import Toppdrag from '../../Components/Topdrag';
import FontAwesome from 'react-fontawesome' ;

import Dropzone from '../../Components/Dropzone';
import Dragzone from '../../Components/Dragzone';

import './style.scss';

class Weland2 extends Component {
    
    constructor(props, context) {
		super(props, context);

        this.state = {
            style: {},
            zoom: .9,
            width:"",
            height:"",
            isMobile: false,

        }
    }
    updateDimensions = () => {
        var w = window,
        d = document,
        documentElement = d.documentElement,
        body = d.getElementsByTagName('body')[0],
        width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
        height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

        this.setState({width: width, height: height});
    }

    zoomIn = (e) => {
        e.preventDefault();
        this.setState((prevState) => {
            return {
                zoom: prevState.zoom + 0.1
            }
        })
    }
    zoomOut = (e) => {
        e.preventDefault();
        this.setState((prevState) => {
            return {
                zoom: prevState.zoom - 0.1
            }
        })
    } 
    componentWillMount = () => {
        this.updateDimensions();
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            this.setState({isMobile: true});
           }
    }
    componentDidMount = () => {
        window.addEventListener("resize", this.updateDimensions);
    }
    componentWillUnmount = () => {
        window.removeEventListener("resize", this.updateDimensions);
    }

    saveHtml = () => {
        let element = document.getElementById('canvas').innerHTML;
        localStorage.setItem('dragdrop-welandutemiljo', element);  
    }

    render = () => {
        const {dragElements, dropElements} = this.props;
        /* if(window.innerWidth === 1350)
        {
            console.log("trueee");
        } */
        let classesDrop;
        let dragElement;
        let topMenu;
        let dropzone;
        
        if(this.state.width < 1350)
        {
            classesDrop = 'column is-12 grid';
            dragElement = "";
            topMenu = (
                <div className="section seconddrag">
                    <div className="columns is-centered">
                            {
                                dragElements.map((value, index) => {
                                    return (
                                        <div className="column is-3" key={index} >
                                            <Toppdrag value={value} index={index} type={value.type} image={value.image} productName={value.name} height={value.height} width={value.width}/>
                                        </div>
                                    )
                                })
                            }
                    </div>
                    <div className="field is-grouped">
                        <p className="control">
                            <button className="button resetbtn" onClick={() => this.props.resetStorage()}>Börja om</button> 
                        </p>
                        <p className="control">
                            <a className="button" href="#" onClick={(e) => this.zoomIn(e)}>
                            <span className="icon"><FontAwesome name='search-plus' size='2x' /></span><span>Större rityta</span>
                            
                            </a> 
                        </p>
                        <p className="control">
                            <a href="#" className="button" onClick={(e) => this.zoomOut(e)}>
                            <span className="icon"><FontAwesome name='search-minus' size='2x' /></span><span>Mindre rityta</span>
                            </a>
                        </p>
                    </div>
                </div>
            )
            
        }else {
            classesDrop = 'column is-9 grid';
            topMenu = "";
            dragElement = (
                <div className="column is-3 is-hidden-mobile">
                    <Dragzone dragElements={dragElements} zoomin={(e) => this.zoomIn(e)} zoomout={(e) => this.zoomOut(e)} />
                </div>
            );
        }

        return (
        
            <div>
                <div className="container is-fluid">
                <Header title="För att rita staketet drar du ut önskad bild på sektionslängd och släpper det i rutnätet." subtitle="Steg 1 / 4 för skapande av staket" hideButton={true} step2={true} activeNextButton={true} saveHtml={() => this.saveHtml()}  nextPageLink="/2"/>
                </div> 
                <div className="hero settingspage">
                    <div className="hero-body">
                        <div className="container is-fluid">
                            <div className="fluid-wrapper">
                                {topMenu}
                                <div className="columns">
                                    {dragElement}
                                    <div className={classesDrop} style={{overflow: 'hidden'}}>
                                        <div className="hero transparent">
                                            <div className="hero-body is-paddingless" id="canvas">
                                                <div className="drop-container" style={{width: '1140px', transform: 'scale(' + this.state.zoom + ')', padding: '10px', margin: 'auto'}}>
                                                
                                                <Dropzone dropHandle={ item => this.dropHandle(item)} dropElements={dropElements} />
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                </div>  
                            </div> 
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}

const mapStateToProps = (state) => {
      return {
          dragElements: state.drag.dragElements,
          dropElements: state.drop.droplEments
      };
  };
  const mapDispatchToProps = (dispatch) => {
	return {
        get_all_drops: bindActionCreators(get_all_drops, dispatch),
        resetStorage: bindActionCreators(resetStorage, dispatch)
	};
}; 
Weland2 = DragDropContext(HTML5Backend)(Weland2);
export default connect(mapStateToProps, mapDispatchToProps)(Weland2);


// WEBPACK FOOTER //
// ./src/Scenes/Weland2/index.js